export default "__VITE_ASSET__lY1tUJ93NGbPkBj1LCstAg__"